import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';

import {
  CheckTooltipsItem,
  CheckTooltipsListFormInput
} from '../check-list-tooltips.model';

@Component({
  selector: 'rpe-check-list-tooltips-form',
  templateUrl: './check-list-tooltips-form.component.html',
  styleUrls: ['./check-list-tooltips-form.component.css']
})
export class CheckListTooltipsFormComponent implements OnInit {
  @Input()
  set formInput(formInput: CheckTooltipsListFormInput) {
    this._formInput = formInput;
    this.ordersData = formInput.elementosCheck;
    this.addCheckboxes();
  }

  get formInput(): CheckTooltipsListFormInput {
    return this._formInput;
  }

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<CheckTooltipsItem[]>();
  _formInput: CheckTooltipsListFormInput = null;

  form: FormGroup;
  ordersData: CheckTooltipsItem[] = [];

  get ordersFormArray() {
    return this.form.controls.orders as FormArray;
  }

  constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      orders: new FormArray([])
    });
  }

  ngOnInit(): void {
    this.form.statusChanges.subscribe((f) => {
      this.formStatusChanges.emit(f);
    });
    this.form.valueChanges.subscribe((_) => {
      const chekeados: CheckTooltipsItem[] = this.obtenerSeleccionados();
      this.formValueChanges.emit(chekeados);
    });
  }

  private addCheckboxes() {
    this.ordersData.forEach((oD) =>
      this.ordersFormArray.push(new FormControl(oD.selected))
    );
    // se emiten las primeras señales con los values y el status
    const checkeados: CheckTooltipsItem[] = this.obtenerSeleccionados();
    this.formValueChanges.emit(checkeados);
    this.formStatusChanges.emit(this.form.status);
  }

  obtenerSeleccionados = () => {
    const selectedOrder = this.ordersFormArray.controls
      .map((control, i) => (control.value ? this.ordersData[i] : null))
      .filter((v) => v !== null);
    return selectedOrder;
  };

  onShowErrors(): void {
    this.form.markAllAsTouched();
  }
}
